import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';

const LoginForm = ({ username, password, isFetching, onPasswordChange, onUsernameChange, onSubmit}) => {
  return (
    <form onSubmit={ onSubmit }>
      <label className={ style.label }>E-post
        <input className={ style.input } type="text" value={ username} onChange={ onUsernameChange } placeholder="Din epostaddress"/>
      </label>
      <label className={ style.label }>Lösenord
        <input className={ style.input } type="password" value={ password } onChange={ onPasswordChange } placeholder="Booli lösenord"/>
      </label>
      <button className={ style.button} disabled={ isFetching } type="submit">Logga in</button>
    </form>
  );
};

LoginForm.propTypes = {
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onUsernameChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default LoginForm;



// WEBPACK FOOTER //
// ./client/src/components/login-form/index.js